module.exports = __webpack_public_path__ + "img/box.0663fd53.svg";